var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack529({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.62,10.92l1.13-.11a1.31,1.31,0,0,0,.41.83,1.23,1.23,0,0,0,.84.27,1.28,1.28,0,0,0,.84-.24.7.7,0,0,0,.28-.55A.53.53,0,0,0,9,10.77a1.16,1.16,0,0,0-.41-.25l-.93-.25a3.13,3.13,0,0,1-1.3-.56,1.47,1.47,0,0,1-.53-1.15,1.42,1.42,0,0,1,.25-.82,1.47,1.47,0,0,1,.71-.58A2.75,2.75,0,0,1,7.92,7a2.43,2.43,0,0,1,1.62.47,1.66,1.66,0,0,1,.57,1.26L9,8.74a1,1,0,0,0-.32-.63,1.16,1.16,0,0,0-.73-.19,1.3,1.3,0,0,0-.79.2.44.44,0,0,0-.19.36.45.45,0,0,0,.18.35,3,3,0,0,0,1.06.38,5.66,5.66,0,0,1,1.25.41,1.61,1.61,0,0,1,.63.58,1.73,1.73,0,0,1,.23.91A1.66,1.66,0,0,1,10,12a1.68,1.68,0,0,1-.77.64,3.44,3.44,0,0,1-1.25.2,2.44,2.44,0,0,1-1.66-.5A2.18,2.18,0,0,1,5.62,10.92Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack529);
export default __webpack_public_path__ + "static/media/Symbolpack_5_29.dab0a3bdf6ff152756e1d6d80fe0bdff.svg";
export { ForwardRef as ReactComponent };